import { render, staticRenderFns } from "./TrademarkNiceClassForm.vue?vue&type=template&id=1d302b67&"
import script from "./TrademarkNiceClassForm.vue?vue&type=script&lang=js&"
export * from "./TrademarkNiceClassForm.vue?vue&type=script&lang=js&"
import style0 from "./TrademarkNiceClassForm.vue?vue&type=style&index=0&id=1d302b67&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports